export const shorthandCssProperties = [
    "margin",
    "marginX",
    "marginY",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "padding",
    "paddingX",
    "paddingY",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "gap",
    "rowGap",
    "columnGap",
    "width",
    "minWidth",
    "maxWidth",
    "height",
    "minHeight",
    "maxHeight",
    "top",
    "right",
    "bottom",
    "left",
    "borderRadius",
    "border",
    "borderTop",
    "borderRight",
    "borderBottom",
    "borderLeft",
    "outline",
    "outlineOffset",
    "outlineWidth",
];
//# sourceMappingURL=css.js.map